import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-zp',
    templateUrl: './zp.component.html',
    styleUrls: ['./zp.component.scss']
})
export class ZpComponent implements OnInit {
    activeItemIndex = 0;
    items = [
        {
            title: 'dashboard',
            icon: 'fa-settings',
            href: 'dashboard'
        }
    ];

    constructor() {
        if (window.location.hash) {
            this.navigateByHash(window.location.hash);
        } else {
            this.onChangeTab(0);
        }
    }

    ngOnInit(): void {

    }

    navigateByHash(hash) {
        this.activeItemIndex = this.items.findIndex(item => item.href === hash.split('#')[2]);
    }

    onChangeTab(index) {
        this.activeItemIndex = index;
        location.hash = `/dashboard#${this.items[this.activeItemIndex].href}`;
    }
}
